module.exports = __webpack_public_path__ + "img/9_128.0c33bc53.png";